import React, { useState } from 'react';
import './FAQ.css';

function FAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question: 'За какви упражнения мога да ги използвам?',
            answer: 'Гриповете са идеални за мъртва тяга, лицеви опори, подтягания, тяга на лат машина, T-бар и щанга редове, машинни дърпания и всички упражнения за укрепване на хващането.'
        },
        {
            question: 'От какъв материал са направени?',
            answer: 'Изработени са от висококачествен PU (полиуретан) с гъвкава, удобна подложка. Повърхността за хващане е антихлъзгаща за максимална сигурност при тренировки.'
        },
        {
            question: 'Колко време отнема доставката?',
            answer: 'Доставяме в рамките на 2 работни дни след потвърждение на поръчката. При поръчка на 2 или повече продукта, доставката е безплатна.'
        },
        {
            question: 'Подходящи ли са за начинаещи?',
            answer: 'Да, гриповете са подходящи както за начинаещи, така и за напреднали. Помагат да подобрите хващането и да вдигате по-тежко с по-малко умора на ръцете.'
        },
        {
            question: 'Каква е гаранцията?',
            answer: 'Продуктите ни са изработени от висококачествени материали и са тествани за издръжливост. При проблеми с продукта, свържете се с нас и ще отговорим.'
        },
        {
            question: 'Мога ли да върна продукта?',
            answer: 'Да, приемаме връщания в рамките на 14 дни след получаване, при условие че продуктът е в оригинално състояние и опаковка.'
        }
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="faq-section" id="faq">
            <h2>Често задавани въпроси</h2>
            <div className="faq-container">
                {faqs.map((faq, index) => (
                    <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
                        <button className="faq-question" onClick={() => toggleFAQ(index)}>
                            <span>{faq.question}</span>
                            <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
                        </button>
                        {openIndex === index && (
                            <div className="faq-answer">
                                <p>{faq.answer}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default FAQ;
